import { AntdInput } from "../views/commonview";
import { Input } from "antd";
import { StyleUtils } from "../utils/Style";
import React from "react";
import { EyeTwoTone, EyeInvisibleOutlined } from "@ant-design/icons";


interface CustomInputProps {
    inputType: "password" | "text",
    placeholder: string
    onChange: (value: string) => void
    value?: string
    autoComplete?: string
}

export default function CustomInput(props: CustomInputProps) {
    const { inputType, onChange, placeholder, value, autoComplete } = props
    return (<AntdInput
    >
        {
            inputType === "password" ?
                <Input.Password
                    size={"large"}
                    value={value}
                    style={{
                        fontSize: StyleUtils.getFont(14),
                        color: "#899199",
                        fontWeight: "400"
                    }}
                    autoComplete={autoComplete ?? "off"}
                    onChange={(e) => {
                        onChange(e.target.value)
                    }}
                    placeholder={placeholder}
                    iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                /> : <Input
                    allowClear
                    size={"large"}
                    autoComplete={autoComplete ?? "off"}
                    style={{
                        fontSize: StyleUtils.getFont(14),
                        color: "#899199",
                        fontWeight: "400"
                    }}
                    onChange={(e) => {
                        onChange(e.target.value)
                    }}
                    placeholder={placeholder}

                />
        }

    </AntdInput>)
}